import { render } from "./CompanyMain.vue?vue&type=template&id=efba8ce2&scoped=true"
import script from "./CompanyMain.vue?vue&type=script&lang=js"
export * from "./CompanyMain.vue?vue&type=script&lang=js"

import "./CompanyMain.vue?vue&type=style&index=0&id=efba8ce2&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efba8ce2"]])

export default __exports__